import BackendRepositoryRemote from '../api/BackendRepositoryRemote';
import { BackendRepository } from '../api/interfaces/BackendRepository';
import { ContactQuestionParams } from '../interfaces/Contact';
import { Customer } from '../interfaces/Customer';
import { RemoteTicket, Ticket } from '../interfaces/Ticket';

export default class TicketService {
  private repository: BackendRepository;

  constructor() {
    this.repository = new BackendRepositoryRemote();
  }

  public cancelTicket(serviceAppointmentId: string): Promise<void> {
    return this.repository.cancelTicket(serviceAppointmentId);
  }

  public async getTicket(ticketHashId: string): Promise<Ticket> {
    const remoteTicket = await this.repository.getTicket(ticketHashId);

    return this.convertRemoteTicketToTicket(remoteTicket);
  }

  public sendContactQuestion(ticketHash: string, params: ContactQuestionParams): Promise<void> {
    return this.repository.sendContactQuestion(ticketHash, params);
  }

  public updateCustomer(ticketHashId: string, customer: Customer): Promise<Customer> {
    return this.repository.updateCustomer(ticketHashId, customer);
  }

  private convertRemoteTicketToTicket(remoteTicket: RemoteTicket): Ticket {
    const workOrder = {
      ...remoteTicket.workOrders[0],
      appointments: undefined,
      appointment: remoteTicket.workOrders[0].appointments[0]
    };

    const ticket = {
      ...remoteTicket,
      workOrders: undefined,
      workOrder: workOrder
    };

    return ticket;
  }
}
